import { alpha } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

type StyleProps = {
  disableContentPadding: boolean
  whiteBackground: boolean
}

export const useStyles = makeStyles<StyleProps>()(
  (
    { palette, spacing, shadows },
    { disableContentPadding, whiteBackground }
  ) => ({
    paper: {
      backgroundColor: whiteBackground ? palette.background.paper : blueGrey[50]
    },
    header: {
      position: "relative",
      backgroundColor: blueGrey[800],
      color: palette.common.white,
      padding: spacing(0, 2)
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      gap: spacing(5)
    },
    backButton: {
      padding: spacing(4),
      color: "inherit"
    },
    backButtonIcon: {
      fontSize: "1.125rem"
    },
    title: {
      fontSize: "1.125rem",
      lineHeight: "1.625rem"
    },
    titleSkeleton: {
      width: "250px",
      height: "26px",
      borderRadius: "3px",
      backgroundColor: alpha(blueGrey[50], 0.3)
    },
    content: {
      padding: disableContentPadding ? 0 : spacing(6, 5),
      height: "100%",
      overflow: disableContentPadding ? "hidden" : "auto",
      display: "flex",
      flexDirection: "column"
    },
    footer: {
      backgroundColor: palette.background.paper,
      padding: spacing(4),
      boxShadow: shadows[6]
    }
  })
)
